export default __webpack_public_path__ + "static/hello_jag_watch-331968ac6a55386d2969c69f8733bd4a.png";